// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1xQBV","title":"Header_title__6Tgbj","left":"Header_left__31Vxf","clinicName":"Header_clinicName__2gwGp"};